import styled from 'styled-components';

import { Loader as LoaderLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled.div`
  padding-top: 100px;
  ${({ center }) => center && `
    display: flex;
    justify-content: center;
  `}
`;

const TextError = styled(TextLayoutComponent.Error)`
  padding: 30px;
  font-size: 4vw;
`;

const Instruction = styled(TextLayoutComponent)`
  margin-bottom: 5px;
`;

const Header = styled(TextLayoutComponent)`
  margin-bottom: 20px;
`;

const Loader = styled(LoaderLayoutComponent).attrs(() => ({
  inline: false,
}))``;

const Message = styled(TextLayoutComponent)`
  margin-bottom: 40px;
  font-size: 18px;
  text-align: center;
`;

export {
  Container,
  Header,
  Loader,
  Message,
  Instruction,
  TextError,
};
